// DefinitionListコンポーネントで使用しやすい形に整形する関数
export const convertToTermAndDescriptionsList = (
  objects: Record<string, string | string[]>[] | null | undefined,
): { term: string; description: string | string[] }[][] => {
  if (!objects) {
    return [];
  }

  return objects.map((object) => {
    return Object.entries(object).map(([term, description]) => {
      return { term, description };
    });
  });
};
